import { axiosInstance } from "../../utils/api"

export const getGallerySetupMoodsApi = async () => {
    return await axiosInstance.get('/gallerysetup/moods');
}